'use client';

import React from 'react';
import { useAppState } from '@/lib/useAppState';
import { SystemUserAvatar, type SystemUserAvatarSize } from '@/components/SystemUserAvatar';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface SystemUserCellProps {
	systemUserId: string;
	showAvatar?: boolean;
	size?: SystemUserAvatarSize;
}

/** Looks up profile data from `workspaceMembers` in Zustand state, not from props. */
export function SystemUserCell({ systemUserId, showAvatar = true, size = 'sm' }: SystemUserCellProps) {
	const workspaceMembers = useAppState((s) => s.workspaceMembers);
	const member = workspaceMembers.find((m) => m.systemUserId === systemUserId);

	const label = member?.name || member?.email || systemUserId.slice(0, 8);
	const tooltip = member?.email && member?.name ? member.email : label;

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<span className={`inline-flex max-w-full items-center ${size === 'xs' ? 'gap-1' : 'gap-2'}`}>
					{showAvatar && <SystemUserAvatar systemUserId={systemUserId} size={size} />}
					<span className="truncate">{label}</span>
				</span>
			</TooltipTrigger>
			<TooltipContent side="bottom" className="text-xs">
				{tooltip}
			</TooltipContent>
		</Tooltip>
	);
}
